import React from 'react';
import { FormattedNumber, useIntl } from 'react-intl';

interface IPriceProps {
    value: number | string | null;
    currency: string | null;
    className?: string;
}

const FormattedPrice: React.FunctionComponent<IPriceProps> = ({ value, currency, className }) => {
    const intl = useIntl();
    const fractionDigits = currency === 'HUF' ? 0 : 2;

    const formatInvalidPrice = () => {
        if (!currency || value === null || typeof value === 'number') {
            return;
        }

        return Number()
            .toLocaleString(intl.locale, { currency, style: 'currency', minimumFractionDigits: 0 })
            .replace('0', value);
    }

    return (
        <>
            {(value !== null && currency) ?
                <span className={className}>
                    {!isNaN(+value) ?
                        <FormattedNumber minimumFractionDigits={fractionDigits} value={+value} style="currency" currency={currency} />
                        : formatInvalidPrice()
                    }
                </span>
                :
                (value !== null && !currency && typeof value === 'string') &&
                <span className={className}>{value}</span>
            }
        </>
    );
}

export default FormattedPrice;